export default "__VITE_ASSET__Bv2hr2IU__"